module.exports = __webpack_public_path__ + "static/background-a05a63676f2c608893866b3005ee393c.png";